webpackJsonp([10],{

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(382);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxMHB4IiB2aWV3Qm94PSIwIDAgMTEgMTAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5saW5rLWFycm93LWdyZXk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iMDEtR2xvYmFsLS0tSG9tZS12MiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ4My4wMDAwMDAsIC03ODAuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9InNlY3Rpb25faGVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDg4LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0icGFnZV9uYXYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMC4wMDAwMDAsIDY0MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzcuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJsaW5rLWFycm93LWdyZXkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgxLjUwMDAwMCwgNTcuMDAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtODEuNTAwMDAwLCAtNTcuMDAwMDAwKSAiIHBvaW50cz0iODEuMjQxMzc4NiA1NC43NzY1NzIzIDc3IDU0Ljc3NjU3MjMgNzcgNTkuMjIzNDI3NyA4MS4yNDEzNzg2IDU5LjIyMzQyNzcgODEuMjQxMzc4NiA2MiA4NiA1Ni45ODkxNTMzIDgxLjI0MTM3ODYgNTIiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(382);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* harmony export (immutable) */ __webpack_exports__["b"] = reset;
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(382);


function getTabsCount(children) {
  var tabCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabList", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resetIdCounter", function() { return __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__["b"]; });






/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(390);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (Tabs.inUncontrolledMode(_this.props)) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    } // Use a transactional update to prevent race conditions
    // when reading the state in copyPropsToState
    // See https://github.com/reactjs/react-tabs/issues/51


    this.setState(function (state) {
      return Tabs.copyPropsToState(newProps, state);
    });
  };

  Tabs.inUncontrolledMode = function inUncontrolledMode(props) {
    return props.selectedIndex === null;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    var newState = {
      focus: focus
    };

    if (Tabs.inUncontrolledMode(props)) {
      var maxTabIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["b" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(382);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










function isNode(node) {
  return node && 'getAttribute' in node;
} // Determine if a node from event.target is a Tab element


function isTabNode(node) {
  return isNode(node) && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return isNode(node) && node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) != null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
      this.panelIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
    } // Map children to dynamically setup refs


    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(499);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Lightbox = function (_React$Component) {
  _inherits(Lightbox, _React$Component);

  function Lightbox(props) {
    _classCallCheck(this, Lightbox);

    var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));

    _this.downloadResource = function (url, filename) {
      if (!filename) {
        filename = url.split('\\').pop().split('/').pop();
      }
      url = url.replace('a.storyblok', 's3.amazonaws.com/a.storyblok');
      fetch(url, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'cors'
      }).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        var blobUrl = window.URL.createObjectURL(blob);
        _this.forceDownload(blobUrl, filename);
      }).catch(function (e) {
        return e;
      });
    };

    _this.state = {
      isViewerOpen: false
    };

    _this.toggleViewer = _this.toggleViewer.bind(_this);
    return _this;
  }

  _createClass(Lightbox, [{
    key: 'toggleViewer',
    value: function toggleViewer(state) {
      this.setState({ isViewerOpen: state });
    }
  }, {
    key: 'forceDownload',
    value: function forceDownload(blob, filename) {
      var a = document.createElement('a');
      a.download = filename;
      a.href = blob;
      a.click();
    }

    // Current blob size limit is around 500MB for browsers

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'content__image', style: { display: 'inline-block' } },
        this.state.isViewerOpen && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: 'lightbox__overlay', onClick: function onClick() {
              return _this2.toggleViewer(false);
            } }),
          _react2.default.createElement(
            'div',
            { className: 'center--absolute' },
            _react2.default.createElement('img', { src: this.props.src, className: 'lighbox__image ' }),
            _react2.default.createElement(
              'button',
              {
                className: 'button button--white button--arrow lightbox__button',
                onClick: function onClick() {
                  return _this2.downloadResource(_this2.props.src);
                },
                target: '_blank',
                download: 'poverty-stoplight-image'
              },
              'DOWNLOAD ',
              _react2.default.createElement('span', { className: 'icon-button-arrow' })
            )
          )
        ),
        _react2.default.createElement('img', {
          src: '//img2.storyblok.com/fit-in/300x200/filters:fill(transparent):format(png)' + this.props.src.replace('//a.storyblok.com', ''),
          onClick: function onClick() {
            return _this2.toggleViewer(true);
          }
        })
      );
    }
  }]);

  return Lightbox;
}(_react2.default.Component);

exports.default = Lightbox;

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAiCAYAAABIiGl0AAAAAXNSR0IArs4c6QAAApBJREFUWAntV89rE0EUnjfZbC3WiKA5+fsiXqyIVDx48NaCWpM0omeh914UGyqLEmn9Ewp6lqRJtYrtzYOIIIIgVPESLCiVIgSyKZtksxnf22Tibk0Wm3TNwTzYfTPvffN9My/D8gLMw6KZsYPCqr0gyEAQrj6JrHz1gLPri6NHy6Z4ShgI8EvZ2PK3dnjeLkHxmlWLCcaG6SlXYcILSznCSDyt9cIrW5Oa0PhqehUobkEhVEMmMnSheCoeqM9av01WDMkMh9/4VDxVA4AGUx1hCyChWmWFBAPAE4oTqPLHhiRhRx5YFRh8YUJkFBZKpq+lK9AQfY3bGemIdJuL8KTvUPwCt0Cf/leitEfSMkG/o+AgIjcNwOb2qQPJR1eeFSkWWRhLYHnu0xh3ei8bX9Fo3M6i6VEN+e7aeYCZxYnlJI1vLo0P5SvlhBDsNs2RK8qR+CRNyPYqg7OPx5d0ugj2ZRBCr2fwDbwZl/mtnjASj4coyDxxErfMkSbHHQZlQD0U3pRj8jzAM3jhPtADHNLOXKuxjZF4gKwT4+QmTc/b2/gAnHESeI2zsZdrmP8rvOcHxEuk25z7xOvrwcn3k91ytl6P3M6ES3jDqGyyHFXLf+tZqXsm7Cp1+PgRdf7svOlHofHuBDdyaxXJ3bMT94XlT+C775fa9xJLgX6pZSV89/9hqbHRbn64iz++D/lV43wuv0dykya2t+ITBk5T0DCsmRvPLz+oGrtcTZ9c0KlXBku7SyV9mppqMtJUsIPMYLtpCwshpgyjMsVYswh1ZJdv03ATAOMLPHzs8Bwe/Y075d+MtIYPnENNNO2Vpnz8+faWEEB/LanBVym+g0Yl/Iz/EzKn9p9/qF3UqjvIvT2qXwxS4VxbGpurAAAAAElFTkSuQmCC"

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/world.85150fb8.png";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(5);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactLazyload = __webpack_require__(70);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _reactTabs = __webpack_require__(402);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

var _axios = __webpack_require__(16);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(497);

__webpack_require__(409);

var _Lightbox = __webpack_require__(498);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _calendar = __webpack_require__(500);

var _calendar2 = _interopRequireDefault(_calendar);

var _linkArrowWhite = __webpack_require__(387);

var _linkArrowWhite2 = _interopRequireDefault(_linkArrowWhite);

var _pdf = __webpack_require__(501);

var _pdf2 = _interopRequireDefault(_pdf);

var _config = __webpack_require__(32);

var _reactRedux = __webpack_require__(15);

var _reactStatic = __webpack_require__(12);

var _world = __webpack_require__(502);

var _world2 = _interopRequireDefault(_world);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var converter = new _showdown2.default.Converter();

// const isSiteInSpanish = typeof window !== 'undefined' && location.href.includes('/es/')

var StopLightKit = function (_React$Component) {
  _inherits(StopLightKit, _React$Component);

  function StopLightKit(props) {
    var _this2 = this;

    _classCallCheck(this, StopLightKit);

    var _this = _possibleConstructorReturn(this, (StopLightKit.__proto__ || Object.getPrototypeOf(StopLightKit)).call(this, props));

    _this.fetchUserData = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios2.default.post(_config.serverURL + '/content', {
                lng: _this.props.lng,
                story: 'kit',
                env: "production"
              });

            case 3:
              response = _context.sent;


              if (response.data.error) {
                window.location.replace('/');
              } else {
                _this.setState({
                  loading: false,
                  stoplightKitData: response.data.stoplightKitData,
                  selected_category: response.data.stoplightKitData.content.all_images_category,
                  filteredImages: response.data.stoplightKitData.content.images
                });
              }
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              window.location.replace('/');

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }));

    _this.selectTab = function (id, index) {
      _this.setState({
        activeTabIndex: index,
        pagesArray: _this.pagesArray(_this.state.stoplightKitData.content[id], index),
        activeTab: id,
        isTabSelected: true,
        page_number: 1
      });
    };

    _this.selectPage = function (page) {
      var content = _this.state.stoplightKitData.content[_this.state.activeTab];

      if (typeof content === 'undefined' || content === null) {
        if (page > 0 && page <= Math.ceil(content ? content.length / _this.limit : _this.state.filteredImages.length / _this.limit)) {
          _this.setState({ page_number: page });
        }
      } else if (content[0].file) {
        if (page > 0 && page <= Math.ceil(content ? content.length / _this.limit2 : _this.state.filteredImages.length / _this.limit2)) {
          _this.setState({ page_number: page });
        }
      } else if (page > 0 && page <= Math.ceil(content ? content.length / _this.limit : _this.state.filteredImages.length / _this.limit)) {
        _this.setState({ page_number: page });
      } else if (page > 0 && page <= Math.ceil(content.length / _this.limit2)) {
        if (!!content[0].author) {
          _this.setState({ page_number: page });
        }
      }
    };

    _this.chooseCategory = function (category) {
      if (category === _this.state.stoplightKitData.content.all_images_category) {
        _this.setState({
          filteredImages: _this.state.stoplightKitData.content.images
        });
      } else {
        _this.setState({
          filteredImages: _this.state.stoplightKitData.content.images.filter(function (item) {
            return item.category && item.category.indexOf(category) > -1;
          })
        });
      }

      setTimeout(function () {
        _this.setState({
          selected_category: category,
          page_number: 1,
          pagesArray: _this.pagesArray()
        });
      }, 100);
    };

    _this.state = {
      activeTabIndex: 1,
      activeTab: '',
      page_number: 1,
      pagesArray: [],
      isTabSelected: false,
      loading: true,
      stoplightKitData: [],
      selected_category: [],
      filteredImages: []
    };
    _this.limit = 21;
    _this.limit2 = 4;
    return _this;
  }

  _createClass(StopLightKit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchUserData();
    }
  }, {
    key: 'pagesArray',
    value: function pagesArray(content, index) {
      if (index === 2 || index === 3) {
        var _temp = [];
        for (var i = 0; i < Math.ceil(content ? content.length / this.limit2 : this.state.filteredImages.length / this.limit2); i += 1) {
          _temp.push(i);
        }
        return _temp;
      }
      var temp = [];
      for (var _i = 0; _i < Math.ceil(content ? content.length / this.limit : this.state.filteredImages.length / this.limit); _i += 1) {
        temp.push(_i);
      }
      return temp;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var content = this.state.stoplightKitData.content;
      var _state = this.state,
          filteredImages = _state.filteredImages,
          pagesArray = _state.pagesArray,
          page_number = _state.page_number;


      return _react2.default.createElement(
        'div',
        null,
        this.state.loading && _react2.default.createElement(
          'div',
          { className: 'relative flex my-56' },
          _react2.default.createElement('div', { className: 'spinner' })
        ),
        !this.state.loading && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactHelmet.Helmet,
            null,
            _react2.default.createElement(
              'title',
              null,
              content && content.top[0].title
            )
          ),
          content && content.top.map(function (el) {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement(
                'div',
                {
                  className: 'hero hero--small',
                  style: {
                    backgroundImage: 'url(' + el.image + ')',
                    backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
                  }
                },
                _react2.default.createElement('div', { className: 'hero__overlay' }),
                _react2.default.createElement(
                  'div',
                  { className: 'wrapper' },
                  _react2.default.createElement(
                    'h1',
                    { className: 'hero__title hero--small__title' },
                    el.title
                  )
                )
              )
            );
          }),
          this.state.isTabSelected ? _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              _reactTabs.Tabs,
              { defaultIndex: this.state.activeTabIndex },
              _react2.default.createElement(
                'div',
                { className: 'col-1-4 tablist__col' },
                _react2.default.createElement(
                  _reactTabs.TabList,
                  { className: 'content__tablist' },
                  content.navigation.map(function (el, i) {
                    return _react2.default.createElement(
                      _reactTabs.Tab,
                      {
                        key: el.id,
                        className: 'content__tab',
                        onClick: function onClick() {
                          return _this3.selectTab(el.id, i);
                        },
                        onKeyPress: function onKeyPress() {
                          return _this3.selectTab(el.id, i);
                        }
                      },
                      el.title
                    );
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-3-4 content__col' },
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    this.props.categories && _react2.default.createElement(
                      'div',
                      { className: 'pagination content__pagination' },
                      [{
                        id: '1',
                        name: this.state.stoplightKitData.content.all_images_category
                      }].concat(_toConsumableArray(this.props.categories)).map(function (category) {
                        return _react2.default.createElement(
                          'div',
                          {
                            key: category.id,
                            className: 'pagination__item ' + (_this3.state.selected_category === category.name ? 'pagination__item--active' : ''),
                            onClick: function onClick() {
                              return _this3.chooseCategory(category.name);
                            },
                            onKeyPress: function onKeyPress() {
                              return _this3.chooseCategory(category.name);
                            }
                          },
                          category.name
                        );
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'content__imageholder' },
                      filteredImages.slice((page_number - 1) * this.limit, (page_number - 1) * this.limit + this.limit).map(function (item) {
                        return _react2.default.createElement(
                          _storyblokReact2.default,
                          { key: item._uid, content: item },
                          _react2.default.createElement(_Lightbox2.default, { src: item.file })
                        );
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    content.videos.map(function (el, i) {
                      if (Math.ceil((i + 1) / _this3.limit) === page_number) {
                        return _react2.default.createElement(
                          _storyblokReact2.default,
                          { key: el._uid, content: el },
                          _react2.default.createElement('div', {
                            className: 'content__video',
                            dangerouslySetInnerHTML: {
                              __html: el.source
                            }
                          }),
                          _react2.default.createElement(
                            'div',
                            { className: 'content__video-info' },
                            _react2.default.createElement(
                              'h2',
                              { className: 'content__video-heading' },
                              el.title
                            ),
                            _react2.default.createElement(
                              'p',
                              { className: 'paragraph--sans' },
                              el.description
                            )
                          )
                        );
                      }
                      return _react2.default.createElement('div', { key: el._uid });
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'content__items__main__container' },
                    content.reports.map(function (el, i) {
                      if (Math.ceil((i + 1) / _this3.limit2) === page_number) {
                        return _react2.default.createElement(
                          _storyblokReact2.default,
                          { key: el._uid, content: el },
                          _react2.default.createElement(
                            'a',
                            { href: el.file || el.link, className: 'content__item__reports' },
                            _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement('div', {
                                style: {
                                  backgroundImage: 'url(' + el.image + ')'
                                },
                                className: 'content__item__reports__image'
                              }),
                              el.year ? _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__yearContainer' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__year' },
                                  el.year
                                )
                              ) : null
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'content__item__reports__rightSide' },
                              _react2.default.createElement(
                                'p',
                                { className: 'content__item__reports__title' },
                                el.title
                              ),
                              el.author ? _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__author' },
                                el.author
                              ) : null,
                              _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__description' },
                                el.description
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__bottomContainer' },
                                el.date ? _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__bottomContainer__itemContainer' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__bottomContainer__iconContainer_calendar' },
                                    _react2.default.createElement('img', {
                                      className: 'content__item__reports__bottomContainer__icon_calendar',
                                      src: _calendar2.default,
                                      alt: 'calendar'
                                    })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__date' },
                                    el.date
                                  )
                                ) : null,
                                el.language ? _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__bottomContainer__itemContainer' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__bottomContainer__iconContainer_world' },
                                    _react2.default.createElement('img', {
                                      className: 'content__item__reports__bottomContainer__icon_world',
                                      src: _world2.default,
                                      alt: 'world'
                                    })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__language' },
                                    el.language
                                  )
                                ) : null
                              )
                            )
                          )
                        );
                      }
                      return _react2.default.createElement('div', { key: el._uid });
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'content__items__main__container' },
                    content.documents.map(function (el, i) {
                      if (Math.ceil((i + 1) / _this3.limit2) === page_number) {
                        return _react2.default.createElement(
                          _storyblokReact2.default,
                          { key: el._uid, content: el },
                          _react2.default.createElement(
                            'a',
                            { href: el.file || el.link, className: 'content__item__reports' },
                            _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement('div', {
                                style: {
                                  backgroundImage: 'url(' + el.image + ')'
                                },
                                className: 'content__item__reports__image'
                              }),
                              el.year ? _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__yearContainer' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__year' },
                                  el.year
                                )
                              ) : null
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'content__item__reports__rightSide' },
                              _react2.default.createElement(
                                'p',
                                { className: 'content__item__reports__title' },
                                el.title
                              ),
                              el.author ? _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__author' },
                                ' ',
                                el.author
                              ) : null,
                              _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__description' },
                                el.description
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'content__item__reports__bottomContainer' },
                                el.date ? _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__bottomContainer__itemContainer' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__bottomContainer__iconContainer_calendar' },
                                    _react2.default.createElement('img', {
                                      className: 'content__item__reports__bottomContainer__icon_calendar',
                                      src: _calendar2.default,
                                      alt: 'calendar'
                                    })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__date' },
                                    el.date
                                  )
                                ) : null,
                                el.language ? _react2.default.createElement(
                                  'div',
                                  { className: 'content__item__reports__bottomContainer__itemContainer' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__bottomContainer__iconContainer_world' },
                                    _react2.default.createElement('img', {
                                      className: 'content__item__reports__bottomContainer__icon_world',
                                      src: _world2.default,
                                      alt: 'world'
                                    })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'content__item__reports__language' },
                                    el.language
                                  )
                                ) : null
                              )
                            )
                          )
                        );
                      }
                      return _react2.default.createElement('div', { key: el._uid });
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'asset__holder' },
                    content.assets.map(function (el) {
                      return el.component === 'Image' ? _react2.default.createElement(
                        _storyblokReact2.default,
                        { key: el._uid, content: el },
                        _react2.default.createElement(
                          'a',
                          { href: el.file },
                          _react2.default.createElement(
                            'div',
                            { className: 'content__asset' },
                            _react2.default.createElement(
                              _reactLazyload2.default,
                              { height: '200' },
                              _react2.default.createElement('img', { className: 'content__asset-image', src: el.file, alt: 'company asset' })
                            )
                          )
                        )
                      ) : _react2.default.createElement(
                        _storyblokReact2.default,
                        { key: el._uid, content: el },
                        _react2.default.createElement(
                          'a',
                          { href: el.file, download: true, rel: 'noopener noreferrer', target: '_blank' },
                          _react2.default.createElement(
                            'div',
                            { className: 'content__asset' },
                            _react2.default.createElement('img', { className: 'content__asset-icon', src: _pdf2.default, alt: 'company PDF' })
                          )
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pagination__wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'pagination' },
                    _react2.default.createElement(
                      _storyblokReact2.default,
                      { content: content.navigation_labels[0] },
                      _react2.default.createElement(
                        'button',
                        {
                          className: 'pagination__item',
                          href: '#',
                          onClick: function onClick() {
                            return _this3.selectPage(page_number - 1);
                          }
                        },
                        content.navigation_labels[0].text
                      )
                    ),
                    pagesArray.map(function (item, i) {
                      return _react2.default.createElement(
                        'span',
                        {
                          key: 'news-' + i,
                          className: 'pagination__item ' + (i + 1 === page_number ? 'pagination__item--active' : ''),
                          href: '#',
                          onClick: function onClick() {
                            return _this3.selectPage(i + 1);
                          },
                          onKeyPress: function onKeyPress() {
                            return _this3.selectPage(i + 1);
                          }
                        },
                        i + 1
                      );
                    }),
                    _react2.default.createElement(
                      _storyblokReact2.default,
                      { content: content.navigation_labels[1] },
                      _react2.default.createElement(
                        'button',
                        {
                          className: 'pagination__item',
                          href: '#',
                          onClick: function onClick() {
                            return _this3.selectPage(page_number + 1);
                          }
                        },
                        content.navigation_labels[1].text
                      )
                    )
                  )
                )
              )
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'wrapper' },
              content.intro.map(function (el) {
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement(
                    'p',
                    { className: 'paragraph--lead content__intro' },
                    el.text
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrapper wrapper--flex mt-60 mb-120' },
              content.navigation.map(function (el, i) {
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'content__nav',
                      onClick: function onClick() {
                        return _this3.selectTab(el.id, i);
                      },
                      onKeyPress: function onKeyPress() {
                        return _this3.selectTab(el.id, i);
                      }
                    },
                    _react2.default.createElement(
                      _reactLazyload2.default,
                      { height: '200' },
                      _react2.default.createElement('img', { className: 'content__nav--image', src: el.image, alt: 'navigation item' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: ' content__nav--overlay' },
                      _react2.default.createElement('img', { className: 'content__nav--arrow', src: _linkArrowWhite2.default, alt: 'navigation arrow' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'bold heading--big content__nav--text' },
                      el.title
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return StopLightKit;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withRouter)((0, _reactStatic.withRouteData)((0, _reactRedux.connect)(function (_ref2) {
  var lng = _ref2.lng,
      user = _ref2.user;
  return {
    lng: lng,
    user: user
  };
})(StopLightKit)));

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/StopLightKit.469366f6.js